/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import DownloadCard from "../downloadpage/sub-components/DownloadCard";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
  },
  flex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "1rem",
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      width: "100%",
      gap: "0rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      width: "100%",
      gap: "0rem",
    },
  },
}));

const SectionFour = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.sectionContainer}>
        <div className={classes.flex}>
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Developer Services"
            href="https://bucket.beegru.in/mandate_marketing.png"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Developer VAS"
            href="https://bucket.beegru.in/developer_vas.jpg"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Landowner Services"
            href="https://bucket.beegru.in/landlord_services.jpg"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Landowner VAS"
            href="https://bucket.beegru.in/landowner_vas.jpg"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Legal Advisory"
            href="https://bucket.beegru.in/legal_advisory.png"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Liaising Advisory"
            href="https://bucket.beegru.in/liaising_advisory.jpg"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Financial Advisory"
            href="https://bucket.beegru.in/funding.png"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="JD/JV and Land Aggregation"
            href="https://bucket.beegru.in/jv_jd.png"
          />
          <DownloadCard
            imageSrc="/images/other/download/image.svg"
            title="Marketing and Branding"
            href="https://bucket.beegru.in/marketing.png"
          />
          <DownloadCard
            imageSrc="/images/other/download/pdf.svg"
            title="RERA Guidelines Brochure"
            href="https://bucket.beegru.in/pdf/rera_brochure.pdf"
          />
          <DownloadCard
            imageSrc="/images/other/download/pdf.svg"
            title="Developer Brochure"
            href="https://bucket.beegru.in/pdf/developer_brochure.pdf"
          />
          <DownloadCard
            imageSrc="/images/other/download/pdf.svg"
            title="Marketing Services Brochure"
            href="https://bucket.beegru.in/pdf/developer_brochure.pdf"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default SectionFour;
